var exports = {
  "kL": "x43aef4ae--c2106a--container",
  "wm": "x43aef4ae--c2106a--logo",
  "yr": "x43aef4ae--c2106a--logo-image",
  "ot": "x43aef4ae--c2106a--logo-icon",
  "pq": "x43aef4ae--c2106a--info",
  "nf": "x43aef4ae--c2106a--link",
};

module.exports = exports;
